import { FC } from 'react';

import { getFileIcon } from 'utils/getFileIcon';
import { formatFileSize } from 'utils/formatFileSize';

import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

type AttachmentChipProps = {
  file: File;
  index: number;
};

const AttachmentChip: FC<AttachmentChipProps> = ({ file, index }) => {
  const { actions } = useSendCommunicationModal();

  const handleRemove = () => {
    actions.handleRemoveAttachment(index);
  };

  return (
    <div key={`${file.name}-${index}`} className="attachment-chip m-1">
      <em
        className={`icon ni ${getFileIcon(file.type)} attachment-chip__icon`}
      />
      <div className="attachment-chip__info">
        <span className="attachment-chip__name">{file.name}</span>
        <span className="attachment-chip__size">
          {formatFileSize(file.size)}
        </span>
      </div>
      <button
        type="button"
        className="attachment-chip__remove btn p-0 d-flex align-items-center justify-content-center"
        onClick={handleRemove}
      >
        <em className="icon ni ni-cross" />
      </button>
    </div>
  );
};

export default AttachmentChip;
